import { ChangeDetectionStrategy, Component } from '@angular/core';
import {PageSubtitleComponent} from "../../../components/page-subtitle/page-subtitle.component";
import {PageTitleLayoutComponent} from "../../../components/page-title-layout/page-title-layout.component";
import {PageSubtitleLayoutComponent} from "../../../components/page-subtitle-layout/page-subtitle-layout.component";
import {
    LotteriesAndFooterComponent
} from "../../../components/lotteries-and-footer/lotteries-and-footer.component";

@Component({
  selector: 'homey-how-it-works',
    imports: [
        PageSubtitleComponent,
        PageTitleLayoutComponent,
        PageSubtitleLayoutComponent,
        LotteriesAndFooterComponent
    ],
  templateUrl: './how-it-works.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HowItWorksComponent {

}
